import { PricesResponseV2 } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as E from "fp-ts/Either"
import * as O from "fp-ts/Option"
import * as ROA from "fp-ts/ReadonlyArray"
import { noAvailabilityForOccupancy, priceResponse } from "../../../test-support/common"
import { cruiseCode } from "./cruisecode"

const prices = [
    E.right(priceResponse(cruiseCode, "CV", { depositPercentage: 25, totalAmount: 11600 })),
    // E.right(priceResponse(cruiseCode, "DX", { depositPercentage: 25, totalAmount: 12600 })),
    E.right(priceResponse(cruiseCode, "G1", { depositPercentage: 25, totalAmount: 24000 })),
    E.right(priceResponse(cruiseCode, "G2", { depositPercentage: 25, totalAmount: 30600 })),
    E.left(noAvailabilityForOccupancy(cruiseCode, "O1")),
    E.left(noAvailabilityForOccupancy(cruiseCode, "O2")),
    E.right(priceResponse(cruiseCode, "R1", { depositPercentage: 25, totalAmount: 23200 })),
    E.right(priceResponse(cruiseCode, "R2", { depositPercentage: 25, totalAmount: 30000 })),
    E.right(priceResponse(cruiseCode, "ME", { depositPercentage: 25, totalAmount: 26000 })),
    // E.right(priceResponse(cruiseCode, "SL", { depositPercentage: 25, totalAmount: 19000 })),
    E.left(noAvailabilityForOccupancy(cruiseCode, "VI")),
    E.right(
        priceResponse(cruiseCode, "SV", {
            depositPercentage: 15,
            totalAmount: 10600,
            availability: "guaranteed",
        }),
    ),
    E.right(
        priceResponse(cruiseCode, "DX", {
            depositPercentage: 15,
            totalAmount: 12600,
            availability: "guaranteed",
        }),
    ),
    E.right(
        priceResponse(cruiseCode, "SL", {
            depositPercentage: 25,
            totalAmount: 12200,
            availability: "partial",
        }),
    ),
]

export const firstGuaranteedPrice = () =>
    F.pipe(
        prices,
        ROA.filter((x) => E.isRight(x) && x.right.availability === "guaranteed"),
        ROA.map(O.fromEither),
        ROA.head,
        O.flatten,
    )

export default PricesResponseV2.build({ prices: prices })
